// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"style_main_wrapper__308Sq","rutube":"style_rutube__2naeI"};